import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-view-succes',
    templateUrl: './view-succes.component.html',
    styleUrls: ['./view-succes.component.css'],
})
export class ViewSuccesComponent {
    mensaje: string;
    displeyIdl = false;
    empresaCreada = false;
    reporteGuardado = false;
    reporteEnviado = false;
    nombreBtn = 'Continuar';
    constructor(private router: Router) {}

    public continuar() {
        if (this.empresaCreada) {
            this.router.navigate(['nueva-empresa']);
            this.displeyIdl = false;
            this.empresaCreada = false;
        } else if (this.reporteGuardado) {
            this.displeyIdl = false;
            this.reporteGuardado = false;
        } else if (this.reporteEnviado) {
            this.router.navigate(['carga-consulta-reportes']);
            this.displeyIdl = false;
            this.empresaCreada = false;
        } else if (this.reporteEnviado) {
            this.router.navigate(['carga-consulta-novedades']);
            this.displeyIdl = false;
            this.empresaCreada = false;
        } else {
            this.router.navigate(['inicio']);
            this.displeyIdl = false;
            this.empresaCreada = false;
        }
    }

    mostrarEmpresa(mensaje: string, reporteEn?: boolean) {
        this.empresaCreada = reporteEn;
        this.mensaje = mensaje;
        this.displeyIdl = true;
    }
    mostrar(mensaje: string, reporteEn?: boolean) {
        this.reporteEnviado = reporteEn;
        this.mensaje = mensaje;
        this.displeyIdl = true;
    }
    mostrarReporte(mensaje: string, reporte?: boolean) {
        this.reporteGuardado = reporte;
        this.mensaje = mensaje;
        this.displeyIdl = true;
    }
}
